<template>
    <b-container>
        <b-row>
            <b-col lg="6" md="8" class="about">
                <div class="content">
                    <h1>
                        E-Learning
                    </h1>
                    <p>
                        Through the use of open-source based solutions such as Moodle, we can provide corporate, religious and education sector with a powerful Learning Management System (LMS) which can attend their needs of education and knowledge transfer.
                    </p>
                    <p>
                        Our e-learning solution is focused on empowering educators and e-learning managers to feed continuously grow their systems without the need on depending on developers for regular maintenance.
                    </p>
                </div>
            </b-col>
            <b-col lg="6" md="4" class="image">
                <img src="../assets/img/e-learning.svg" alt="E-Learning">
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
  export default {
    name: 'ELearning'
  }
</script>

<style scoped>
</style>